import { Card } from '@mui/material';
import styled from 'styled-components';

const getWidgetHeight = ({
  $variant = 'default',
  $isSmallDesktop,
  $isExpanded = false,
}: {
  $variant: 'tall' | 'default';
  $isSmallDesktop: boolean;
  $isExpanded?: boolean;
}) => {
  if ($isSmallDesktop) return 90;

  if ($variant === 'tall') {
    return $isExpanded ? 175 : 125;
  }

  return 90;
};

export const Widget = styled(Card)<{
  $variant: 'tall' | 'default';
  $isSmallDesktop: boolean;
  $isExpanded?: boolean;
}>`
  width: 100%;
  background: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundPaperDark : color.white};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
  transition: height 0.3s ease;
  height: ${({ theme: { spacing }, $variant, $isSmallDesktop, $isExpanded }) =>
    spacing(getWidgetHeight({ $variant, $isSmallDesktop, $isExpanded }))};
`;
